module.exports = __webpack_public_path__ + "img/1-04.eac7f03d.jpg";